import PropTypes from "prop-types";
import React from "react";
import IconBase from "./IconBase";

export function AddressIcon({ width = 20, ...props }) {
  return <IconBase src="/img/icons/location.png" width={width} {...props} />;
}

AddressIcon.propTypes = {
  width: PropTypes.number,
};
